var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLifecycleInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.45,
    fill: "#E7ECFC",
    stroke: "#295EF1",
    strokeWidth: 1.1,
    strokeLinejoin: "round",
    strokeDasharray: "2.5 2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLifecycleInprogress);
export default __webpack_public_path__ + "static/media/icon-lifecycle-inprogress.7d613e4e45b5c292c1bc7488cd75bc19.svg";
export { ForwardRef as ReactComponent };